
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import styles from './SimplePage.module.css';
import MobiStyles from './SimplePageMobi.module.css';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import utilsSinglePage from '../Connections/_Utils/utilsSinglePage';
import { CurrentPContext } from '../Contexts/CurrentP_Context';

const SimplePage = (props) => {
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);
    const [pageDetails, setPageDetails] = useState();
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

   
    useEffect(() => {
        setCurrentStyle(!mobiOrNot ? styles : MobiStyles)
    }, [mobiOrNot]);

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSinglePage.getSinglePageById(props.pageID)
            setPageDetails(pg);
            setCurrentPage({ ...pg, pageTYp: "" });
        }
        getPageDetalis();
    }, [])

    return (
        <div className={`${currnetStyle.MainMenuPage} regularPoint `}>
            {pageDetails &&
                <>
                    <div className={pageDetails.withOutOpenintxt ? currnetStyle.TopWrapNoMarg : currnetStyle.TopWrap}>
                        <div className={currnetStyle.TopImg}
                            style={{
                                backgroundImage:
                                    `url("${ConnUrls.servMediasUrl}${!mobiOrNot || !pageDetails.openingImageMobi ? pageDetails.openingImage : pageDetails.openingImageMobi}")`
                            }}>

                            <div className={currnetStyle.TopTxtBlock}>
                                {!pageDetails.withOutOpenintxt &&
                                    <div className={`${currnetStyle.InBlockTxt} animate__animated animate__zoomInDown regularPoint`}>
                                        <div className={`${currnetStyle.theTxt}`}>
                                            {parse(`${pageDetails.openingContent}`)}
                                        </div>
                                    </div>

                                }
                            </div>
                        </div>
                    </div>
                    <h1 className={currnetStyle.mainTextHead}>
                        {pageDetails.mainTitle}
                    </h1>
                    <div className={currnetStyle.mainText}>
                        {parse(`${pageDetails.mainContent}`)}
                    </div>
                </>
            }
        </div >


    );
}

export default SimplePage;
